export default __webpack_public_path__ + "static/media/alertIconGreen.567257b7.svg";